import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { useEffect, useState } from 'react'
import { getAdminConfig, setAdminConfig } from 'services'
import { RenderInput } from 'utils/RenderInput'

import { defaultInputs } from './constant'

const placeholders = ['full_name']
export const ApplicationEmailTemplate = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState<Record<string, any>>({})
  const [changed, setChanged] = useState(false)
  const [inited, setInited] = useState(false)
  const inputs = defaultInputs()

  useEffect(() => {
    setIsLoading(true)
    getAdminConfig('applicationEmail').then((res) => {
      setData(res)
      setIsLoading(false)
    })
  }, [])

  const onChange = (key: string, value: any) => {
    const temp = cloneDeep(data)
    temp[key] = value
    setData(temp)
    if (inited) setChanged(true)
    if (key === 'content' && data[key] === value) setInited(true)
  }

  const onSubmit = async () => {
    setIsLoading(true)
    await setAdminConfig('applicationEmail', data)
    setIsLoading(false)
    setChanged(false)
  }

  return (
    <div className="relative">
      <LayoutLoading show={isLoading} />
      <h2 className={`text-2xl font-bold flex items-center mb-4`}>Loan Application Email Template</h2>
      <div className="mb-6">
        <p className="ml-3 text-lg font-medium mb-2">- Placeholders</p>
        <div className="p-3 border rounded-md">
          <div className="flex gap-x-1 gap-y-3 flex-wrap justify-between">
            {placeholders.sort().map((item, index) => {
              return (
                <pre key={index} className="w-[240px] cursor-pointer">
                  {item}
                </pre>
              )
            })}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-2">
        {Object.keys(inputs).map((key) => {
          const input = inputs[key]
          input.value = data[key]
          return (
            <div className="col-span-1">
              <RenderInput input={input} Key={key} onChange={onChange} />
            </div>
          )
        })}
      </div>
      <SaveChanges show={changed} onSave={onSubmit} />
    </div>
  )
}
